import { render, staticRenderFns } from "./SettingsVectorCollections.vue?vue&type=template&id=8beaa63e&"
import script from "./SettingsVectorCollections.vue?vue&type=script&lang=js&"
export * from "./SettingsVectorCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports